module.exports = "/cyber/_next/static/images/regionSteamSlide-5d11fef0e0928dc1cde1db9347e05e3e.jpg";